var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows / right_0xe822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6641 9.9974C16.6641 9.53716 16.291 9.16406 15.8307 9.16406L4.16406 9.16406C3.70382 9.16406 3.33073 9.53716 3.33073 9.9974C3.33073 10.4576 3.70383 10.8307 4.16406 10.8307L15.8307 10.8307C16.291 10.8307 16.6641 10.4576 16.6641 9.9974Z",
    fill: "#001E64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5919 3.58002C10.2664 3.25458 9.73879 3.25458 9.41335 3.58002L3.58002 9.41335C3.25458 9.73878 3.25458 10.2664 3.58002 10.5919L9.41335 16.4252C9.73879 16.7506 10.2664 16.7506 10.5919 16.4252C10.9173 16.0998 10.9173 15.5721 10.5919 15.2467L5.34778 10.0026L10.5919 4.75853C10.9173 4.43309 10.9173 3.90545 10.5919 3.58002Z",
    fill: "#001E64"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow_left-icon.34e646317f65b28db79168ae7d8e925c.svg";
export { ForwardRef as ReactComponent };